module.exports = __webpack_public_path__ + "img/documents-hover.3eeae183.svg";